import { makeApiCall } from "../apiRequest";

export default {
  state: {
    roomList: [],
    roomById: null,
    managers: [],
    floorList: []
  },
  getters: {
    getRoomList: (state) => state.roomList,
    getRoomById: (state) => state.roomById,
    getMangers: (state) => state.managers,
    getFloorList: (state) => state.floorList
  },
  actions: {
    async getRoomList({ commit }, obj) {
      let url = "room/getAll";

      const response = await makeApiCall(url, "POST", obj);
      if (!response.error) {
        commit("setRoomList", response.data);
      }
      return response;
    },
    async deleteRoom({ commit }, obj) {
      const response = await makeApiCall("room/delete", "DELETE", obj);
      return response;
    },
    async createRoom({ commit }, payload) {
      const response = await makeApiCall("room/save", "POST", payload);
      return response;
    },
    async getMangers({ commit }) {
      let url = `room/getAllManagers?isRoomAssigned=true`;
      const response = await makeApiCall(url, "POST");
      if (!response.error) {
        commit("setManagers", response.data);
      }
      return response;
    },
    async getRoomById({ commit }, payload) {
      const response = await makeApiCall("room/getAll", "POST", payload);
      if (!response.error && response.data.data.length > 0) {
        commit("setRoomById", response.data);
      }
      return response;
    },
    async getFloorList({commit}){
    const response = await makeApiCall('room/getAllFloors','GET');
    if(!response.error){
      commit('setFloorList', response.data.data)
    }
    }
  },
  mutations: {
    setRoomList: (state, payload) => (state.roomList = payload),
    setManagers: (state, payload) => (state.managers = payload),
    setRoomById: (state, payload) => (state.roomById = payload),
    setFloorList: (state,payload) => state.floorList = payload
  },
};
